import {
  Component, OnInit, Input, HostBinding, forwardRef, OnChanges,
  SimpleChanges, ChangeDetectionStrategy, ChangeDetectorRef
} from '@angular/core';
import { AbstractControl, NG_VALUE_ACCESSOR, ControlValueAccessor, NG_VALIDATORS, FormControl } from '@angular/forms';
import { NgbDateStruct, NgbDateParserFormatter } from '@ng-bootstrap/ng-bootstrap';
import { CustomNgbDateParserFormatter } from '../../models/custom-ngb-date-parser-formatter';
import { IMultiDropdownData } from '../multi-dropdown/multi-dropdown.component';

@Component({
  selector: 'app-form-group',
  templateUrl: './form-group.component.html',
  styleUrls: ['./form-group-component.scss'],
  changeDetection: ChangeDetectionStrategy.Default,
  providers: [
    { provide: NG_VALUE_ACCESSOR, useExisting: forwardRef(() => FormGroupComponent), multi: true },
    { provide: NG_VALIDATORS, useExisting: forwardRef(() => FormGroupComponent), multi: true },
    { provide: NgbDateParserFormatter, useClass: CustomNgbDateParserFormatter }
  ]
})
export class FormGroupComponent implements ControlValueAccessor, OnChanges, OnInit {

  /**
   * definition of valid type values
   *
   * @private
   * @static
   * @memberof FormGroupComponent
   */
  private static _Types = ['date', 'dropdown', 'multi-dropdown', 'text', 'textarea', 'time-combobox'];

  dateModel: NgbDateStruct;

  control: AbstractControl;

  innerValue = '';

  @HostBinding('class.form-group') cfg = true;

  @Input() id: string;

  @Input() type: string;

  @Input() text: string;

  @Input() subtext: string;

  @Input() placeholder: string;

  @Input() required: boolean;

  @Input() rows: number;

  @Input() ariaDescribedby: string;

  @Input() formControlName: string;

  @Input() form: string;

  @Input() selectData: IMultiDropdownData;

  @Input() firstAsDefault: boolean;

  @Input() autofocus: boolean;

  @Input() hideLabels: boolean;

  @Input() targetDate: Date;

  @Input() placement = 'bottom-right';

  /**
   * Indicates whether strings should be trimmed or not (default true)
   *
   * @memberof FormGroupComponent
   */
  @Input() trimStrings = true;

  disabled: boolean;

  constructor(private cd: ChangeDetectorRef) { }

  private propagateChange: (newValue: any) => void = (_: string) => { };

  validateFn: any = () => { };

  ngOnInit() {
    if (!this.id) {
      throw new Error(`Attribute "id" of FormGroupComponent is required`);
    }
    if (this.text === undefined) {
      throw new Error(`Attribute "text" of FormGroupComponent is required`);
    }
    if (FormGroupComponent._Types.indexOf(this.type) < 0) {
      throw new Error(`Attribute "type" of FormGroupComponent can not be "${this.type}"`);
    }
  }

  /**
   * DOM change event triggered by programatically (i.e. rebinding of attributes)
   * @param x change event
   */
  onChange(x: any) {
    let value = x.target.value;
    if (this.trimStrings && typeof value === 'string') {
      value = value.trim();
    }

    this.innerValue = value;
    this.propagateChange(value);
  }

  onKeyUp(value: string) {
    const x = debounce(() => {
      this.propagateChange(value);
    }, 400, false);
    x();
  }

  /**
   * ng change event
   * @param value new value
   */
  onValueChange(value: string) {
    this.innerValue = value;
    this.propagateChange(value);
  }

  /**
   * handles date change of input or date selected
   *
   * @memberof FormGroupComponent
   */
  onDateChange() {
    if (this.dateModel !== null && this.dateModel.year && this.dateModel.month && this.dateModel.day) {
      this.propagateChange(CustomNgbDateParserFormatter.toDate(this.dateModel).toISOString());
    } else {
      this.propagateChange(null);
    }
  }

  ngOnChanges(changes: SimpleChanges) {

  }

  writeValue(value: any) {
    if (value !== undefined) {
      this.innerValue = value || '';
    }
    if (this.type === 'date') {
      this.dateModel = CustomNgbDateParserFormatter.toNgbDate(new Date(value));
    }
    this.propagateChange(value);
    // this.cd.markForCheck();
  }

  // // get accessor
  // get value(): any {
  //   return this.innerValue;
  // }
  // // set accessor including call the onchange callback
  // set value(v: any) {
  //   if (v !== this.innerValue) {
  //     this.innerValue = v;
  //     this.propagateChange(v);
  //   }
  // }

  registerOnChange(fn) {
    this.propagateChange = fn;
  }

  registerOnTouched(fn) {
  }

  validate(c: FormControl) {
    return this.validateFn(c);
  }

  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

}
